import axios from 'axios';
import {getConfig} from '../util/configUtil';

const URL = getConfig('healthCheckService', null);

class APIHealthService {
    static async getHl7PasStatus() {
        if (!URL) {
            throw new Error('Health Service URL is not defined');
        }

        return new Promise(function (resolve, reject) {
            axios.get(URL + '/hl7')
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
}

export default APIHealthService;